var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImproveCapture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 48.26 49.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "      .cls-1, .cls-2 {        fill: none;      }      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {        stroke-linecap: round;        stroke-linejoin: round;        stroke-width: 1.3px;      }      .cls-1, .cls-3, .cls-4 {        stroke: #fff;      }      .cls-2 {        stroke: #474b52;      }      .cls-6, .cls-5 {        fill: #28b24c;      }      .cls-3 {        fill: #ffc92e;      }      .cls-4 {        fill: #fff;      }      .cls-5 {        stroke: #28b24c;      }    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.54 14.27 8.14 19.71 6.1 17.67 8.14 19.71 11.54 14.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.52 19.71 14.27 19.71 26.52 19.71 26.52 19.71"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.54 23.11 8.14 28.56 6.1 26.52 8.14 28.56 11.54 23.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.52 28.56 14.27 28.56 26.52 28.56 26.52 28.56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.54 31.96 8.14 37.41 6.1 35.37 8.14 37.41 11.54 31.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.52 37.41 14.27 37.41 26.52 37.41 26.52 37.41"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.24,6.1h-4.46c.23.4.38.86.38,1.36v1.36H7.46v-1.36c0-.5.14-.96.38-1.36H3.37c-1.5,0-2.72,1.23-2.72,2.72v31.31c0,1.5,1.23,2.72,2.72,2.72h25.87c1.5,0,2.72-1.23,2.72-2.72V8.82c0-1.5-1.23-2.72-2.72-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.9,4.05c0-2.75,3.27-4.74,6.13-2.3.44.37.67.93.67,1.51v1.48s4.32,0,4.32,0c.62,0,1.12.5,1.12,1.12v2.96H7.46v-2.96c0-.62.5-1.12,1.12-1.12h4.32v-.68Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 16.31,
    cy: 4.05,
    r: 0.68
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 38.08,
    cy: 37.41,
    r: 9.94
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.32,40.45c.69,1.38,2.07,1.38,2.07,1.38h1.44c1.1,0,2.01-.9,2.01-2.01v-.48c0-1.06-.87-1.93-1.93-1.93h-1.66c-1.06,0-1.93-.87-1.93-1.93h0c0-1.06.87-1.93,1.93-1.93h1.52s1.38,0,2.07,1.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.08,
    y1: 31.89,
    x2: 38.08,
    y2: 33.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.08,
    y1: 41.83,
    x2: 38.08,
    y2: 42.93
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.41,
    y1: 24.76,
    x2: 40.41,
    y2: 13.69
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "35.21 18.89 40.41 13.7 45.61 18.89"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImproveCapture);
export default __webpack_public_path__ + "static/media/Improve_Capture.a928fe0d25bb9f5279fdfc6b8b1f7be5.svg";
export { ForwardRef as ReactComponent };